<template>
    <CModal
        :show.sync="modal"
        color="primary"
        size="lg"
        :closeOnBackdrop="false"
        >
        <template #header>
            <h5> <font-awesome-icon icon="user"/> Icons list </h5>
            <CButton 
                class="pull-right" 
                color="light" 
                shape="pill" 
                size="sm"
                @click="modal = false"
            >
                <font-awesome-icon icon="times"/>
            </CButton>
        </template>
        <template #body-wrapper>
            <CCardBody>
                <CDataTable
                    :items="icons"
                    :fields="icon_fields"
                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                    :items-per-page="10"
                    items-per-page-select
                    @row-clicked="selectedIcon"
                    border
                    sorter
                    pagination
                >
                <template #icon="{item}">
                    <td>
                        <CIcon :name="toKebabCase(item.name)" size="xl" />
                    </td>
                </template> 
                <template #name="{item}">
                    <td>
                        {{toKebabCase(item.name)}}
                    </td>
                </template> 
                
                </CDataTable>
            </CCardBody>
        </template>
        <template #footer>
            <hr hide>
        </template>
    </CModal>
</template>
<script>
import { freeSet } from '@coreui/icons'
export default {
    name: 'IconModal',
    freeSet,
    data () {
        return {
            modal: false,
            icons: [],
            icon_fields:[
                { key: 'icon',},
                { key: 'name' },
            ],
            selected: null,
        }
    },
    created() {
        this.$parent.$on('show_icons_modal', this.breakdownIcon);
    },
    methods: {
        breakdownIcon: function() {
            this.icons = [];
            for(let icon in this.$options.freeSet) {
                let row = {
                    icon: icon,
                    name: icon
                }
                this.icons.push(row)
            }
        },
        toKebabCase (str) {
            return str.split('').map((letter, idx) => {
                return letter.toUpperCase() === letter
                ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                : letter;
            }).join('');
        },
        selectedIcon: function(item, index, column, event){
            this.selected = this.toKebabCase(item.name)
            this.modal = false;
        }
    }

}
</script>